// import Vue from 'vue'
// import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

// Vue.use(Router)

// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'HelloWorld',
//       component: HelloWorld
//     }
//   ]
// })
import Vue from 'vue';
import Login from '@/components/Login.vue';
import Signup from '@/components/Signup.vue';
import CompleteSignup from '@/components/CompleteSignup.vue';
import ForgotPassword from '@/components/ForgotPassword.vue';
import RecoverPassword from '@/components/RecoverPassword.vue';
import Confirmation from '@/components/Confirmation.vue';
import Dashboard from '@/components/dashboard/Dashboard.vue';
import UpdateProfile from '@/components/dashboard/UpdateProfile.vue';
import Orders from '@/components/dashboard/Orders.vue';
import AllDisputes from '@/components/dashboard/AllDisputes.vue';
import RaiseDispute from '@/components/dashboard/RaiseDispute.vue';
import SingleDispute from '@/components/dashboard/SingleDispute.vue';
import DeliveryTerms from '@/components/dashboard/DeliveryTerms.vue';
import CreateOrder from '@/components/dashboard/CreateOrder.vue';
import OrderConfirmation from '@/components/dashboard/OrderConfirmation.vue';
import PaymentHistory from '@/components/dashboard/PaymentHistory.vue';
import PersonToPerson from '@/components/dashboard/PersonToPerson.vue';
import PersonToPersonStage2 from '@/components/dashboard/PersonToPersonStage2.vue';
import PersonToPersonStage2Milestone from '@/components/dashboard/PersonToPersonStage2Milestone.vue';
import PersonToPersonStage3 from '@/components/dashboard/PersonToPersonStage3.vue';
import PersonToPersonStage3Milestone from '@/components/dashboard/PersonToPersonStage3Milestone.vue';
import TransactionStatusHelp from '@/components/dashboard/TransactionStatusHelp.vue';
import GetVerified from '@/components/dashboard/GetVerified.vue';
import CourierServices from '@/components/dashboard/CourierServices.vue';
import Dispatchers from '@/components/dashboard/Dispatchers.vue';
import CreateApiKey from '@/components/dashboard/CreateApiKey.vue';
import Payout from '@/components/dashboard/Payout.vue';
import PayoutDetails from '@/components/dashboard/PayoutDetails.vue';
import PaymentEngine from '@/components/PaymentEngine.vue';
import Settings from '@/components/dashboard/settings.vue';
import Support from '@/components/dashboard/support.vue';
import SellerSupport from '@/components/dashboard/sellersupport.vue';


import Router from 'vue-router'
Vue.use(Router);

// export const routes = [
// export default new Router({

//   mode: 'history',
//   routes: [
const routes = [
    
    { 
        path: '/', 
        name: 'logins',
        component: Login 
    },
    { 
        path: '/login', 
        name: 'login',
        component: Login 
    },
    { 
        path: '/signup',
        name: 'signup', 
        component: Signup 
    },
    { 
        path: '/signup/returning/:email/:phone',
        name: 'complete-signup', 
        component: CompleteSignup 
    },
    { 
        path: '/forgot', 
        name: 'forgot',
        component: ForgotPassword 
    },
    { 
        path: '/:role/confirmation/:token', 
        name: 'confirmation',
        component: Confirmation 
    },
    { 
        path: '/:role/forgot/:token', 
        name: 'recoverpassword',
        component: RecoverPassword 
    },
    { 
        path: '/payment/engine', 
        name: 'payment-engine',
        component: PaymentEngine 
    },


    //end to end routes
    { 
        path: '/order/create', 
        name: 'create-order',
        component: CreateOrder,
        beforeRouteEnter (to, from, next) {
            next(vm => {
                // access to component instance via `vm`
                if(vm.$session.get('trustpayauthtoken') == null){
                    next(false);
                }
                next();
            });
        } 
    },
    { 
        path: '/order/confirmation', 
        name: 'confirm-order',
        component: OrderConfirmation,
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if(vm.$session.get('trustpayauthtoken') == null){
                    next(false);
                }
                next();
            });
        } 
    },

    //post authentication routes
    { 
        path: '/myescrow/welcome', 
        name: 'dashboard',
        component: Dashboard 
    },
    {
        path: '/myescrow/p2p/stage1', 
        name: 'p2p',
        component: PersonToPerson 
    },
    {
        path: '/myescrow/p2p/stage2', 
        name: 'p2p-stage2',
        component: PersonToPersonStage2 
    },
    {
        path: '/myescrow/p2p/stage2milestone', 
        name: 'p2p-stage2milestone',
        component: PersonToPersonStage2Milestone 
    },
    {
        path: '/myescrow/p2p/stage3milestone', 
        name: 'p2p-stage3milestone',
        component: PersonToPersonStage3Milestone 
    },
    {
        path: '/myescrow/p2p/stage3', 
        name: 'p2p-stage3',
        component: PersonToPersonStage3 
    },
    {
        path: '/myescrow/profile/update', 
        name: 'profile',
        component: UpdateProfile 
    },
    {
        path: '/myescrow/orders', 
        name: 'orders',
        component: Orders 
    },
    {
        path: '/myescrow/disputes/all', 
        name: 'all-disputes',
        component: AllDisputes 
    },
    {
        path: '/myescrow/dispute/:disputeId', 
        name: 'single-dispute',
        component: SingleDispute 
    },
    {
        path: '/myescrow/disputes/new/:orderId',
        name: 'raise-dispute',
        component: RaiseDispute 
    },
    {
        path: '/myescrow/paymenthistory',
        name: 'payment-history',
        component: PaymentHistory 
    },
    {
        path: '/myescrow/support',
        name: 'support',
        component: Support 
    },
    {
        path: '/myescrow/help',
        name: 'transaction-status-help',
        component: TransactionStatusHelp 
    },
    

    //seller
    {
        path: '/myescrow/deliveryterms',
        name: 'delivery-terms',
        component: DeliveryTerms 
    },
      {
        path: '/myescrow/settings',
        name: 'settings',
        component: Settings 
    },
    {
        path: '/myescrow/verify',
        name: 'get-verified',
        component: GetVerified 
    },
    {
        path: '/myescrow/seller/support',
        name: 'sellersupport',
        component: SellerSupport 
    },
    {
        path: '/myescrow/courier',
        name: 'courier-services',
        component: CourierServices
    },
    {
        path: '/myescrow/dispatchers/all',
        name: 'all-dispatchers',
        component: Dispatchers
    },
    { 
        path: '/myescrow/api', 
        name: 'create-api-key',
        component: CreateApiKey 
    },
    { 
        path: '/myescrow/payout-history', 
        name: 'payout',
        component: Payout 
    },
    { 
        path: '/myescrow/payout-details', 
        name: 'payout-details',
        component: PayoutDetails 
    },
    { 
        path: '*', 
        component: { template: '<h1>Page Not Found</h1>'} 
    },
];
// })
import { Loading } from 'element-ui';

// })
const router = new Router({
  routes,
  mode: 'history'
})


router.beforeEach((to, from, next) => {

		const loading =  Loading.service({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 1500);

  // iView.LoadingBar.start();
  next();
});

router.afterEach(route => {
  // iView.LoadingBar.finish();
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js